import msalInstance from '../../services/msal/msal';
import {
	InteractionRequiredAuthError,
	SilentRequest,
} from '@azure/msal-browser';

/**
 * Asynchronous helper function to retrieve access token for specified resource on behalf of logged-in user. Retrieval is performed silently; on failure, via redirect.
 * @param {SilentRequest} request authorization request configuration(s).
 * @returns {Promise<string>} obtained resource access token.
 */
export const acquireAccessToken = async request => {
	let authResult = null;
	let accessToken = null;

	// asynchronous authentication response handler
	const redirectResult = await msalInstance.handleRedirectPromise();

	try {
		// not coming back from authentication redirect or an authentication redirect for other resource
		if (
			redirectResult === null ||
			!redirectResult.scopes.some(scope => request.scopes.includes(scope))
		) {
			// acquireTokenSilent() will raise "BrowserAuthError" if active account not set; force redirect to reset account
			if (!msalInstance.getActiveAccount()) {
				throw new InteractionRequiredAuthError();
			}

			authResult = await msalInstance.acquireTokenSilent({
				...request,
			});
		} else {
			authResult = redirectResult;

			// preserve active account since redirect treated as different from login
			msalInstance.setActiveAccount(redirectResult?.account);
		}
	} catch (e) {
		if (e instanceof InteractionRequiredAuthError) {
			try {
				return msalInstance.acquireTokenRedirect({
					...request,
				});
			} catch (e) {
				throw e;
			}
		} else {
			throw e;
		}
	} finally {
		accessToken = authResult?.accessToken;
	}

	return accessToken;
};